/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { User } from './user';
import { State } from './state';
import * as moment from 'moment';
import { ReportDelay } from './report';

export class HistoryStage {
  HID: string;
  DATE: Date;
  USER: User;
  ASSIGNEE: User;
  SID: string;
  P_SID: string;
  STATE: State;
  NOTE: string;
  FILE_LOCATION: string;
  DELAY: ReportDelay;

  // helpers
  DATE_ENGAGED: string;

  static parse(json: any): HistoryStage {
    if (json) {
      const h = new HistoryStage();

      h.HID = json.HID;
      h.DATE = new Date(json.DATE);
      h.SID = json.SID;
      h.P_SID = json.P_SID;
      h.NOTE = json.NOTE;
      h.FILE_LOCATION = json.FILE_LOCATION;

      if (json.DATE_ENGAGED)
        h.DATE_ENGAGED = moment(json.DATE_ENGAGED).format("MMM DD, YYYY");

      if (json.USER)
        h.USER = User.parse(json.USER);
      if (json.ASSIGNEE)
        h.ASSIGNEE = User.parse(json.ASSIGNEE);
      if (json.STATE)
        h.STATE = State.parse(json.STATE);

      if(json.DELAY)
        h.DELAY = ReportDelay.parse(json.DELAY);

      return h;
    } else return null;
  }

  static parseArray(json: any[]): HistoryStage[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(HistoryStage.parse(j));

    return arr;
  }
}
